module.exports = __webpack_public_path__ + "static/media/3pic.a34aab65.png";